import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mb_order_routing_overview = _resolveComponent("mb-order-routing-overview")!

  return (_openBlock(), _createBlock(_component_mb_order_routing_overview, {
    type: 1,
    store_id: "16,25"
  }))
}